<div class="flex flex-col w-full">
    <ng-container *ngIf="signatureService.opened">
        <app-signature></app-signature>
    </ng-container>
    <app-maintenance-statusbar></app-maintenance-statusbar>
    <router-outlet></router-outlet>
</div>
